




import React, { useState, useEffect, useRef } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import './AdminLayout.css';
import logo from './logo.png';
function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef();
  const location = useLocation();
  const navigate = useNavigate(); // ✅ useNavigate for redirect

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Close sidebar when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarOpen
      ) {
        setSidebarOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebarOpen]);

  // Close sidebar on route change (for mobile/tablet)
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  }, [location]);

  // ✅ Logout handler
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/'); // Redirect to login page
  };

  return (
    <div className="admin-layout d-flex">
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`sidebar bg-success text-white p-3 ${sidebarOpen ? 'open' : ''}`}
      >
      <img src={logo} className='image-fluid  align-items-start justify-content-end ' alt='logo'/>
        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <Link to="/dashboard" className="nav-link text-white">
              <i className="bi bi-bar-chart-fill me-2"></i> Dashboard
            </Link>
          </li>
          <li className="nav-item mb-2">
            <Link to="/products" className="nav-link text-white">
              <i className="bi bi-box-seam me-2"></i> Products
            </Link>
          </li>
          <li className="nav-item mb-2">
            <Link to="/orders" className="nav-link text-white">
              <i className="bi bi-receipt me-2"></i> Orders
            </Link>
          </li>

          <li className="nav-item mb-2">
  <Link to="/admin/sections" className="nav-link text-white">
    <i className="bi bi-ui-checks-grid me-2"></i> Section Manager
  </Link>
</li>

          <li className="nav-item mb-2">
            <Link to="/categories" className="nav-link text-white">
              <i className="bi bi-tags me-2"></i> Categories
            </Link>
          </li>
          <li className="nav-item mb-2">
            <Link to="/slides" className="nav-link text-white">
              <i className="bi bi-image me-2"></i> Slides
            </Link>
          </li>

          {/* ✅ Logout Button */}
          <li className="nav-item mt-4">
            <button
              className="btn btn-outline-light w-80 py-2 px-4"
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right me-2 "></i> Logout
            </button>
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="main-content flex-grow-1 bg-light">
        {/* Topbar */}
        <nav className="navbar navbar-light bg-white shadow-sm px-3 d-md-none">
          <button className="btn btn-outline-dark" onClick={toggleSidebar}>
            <i className="bi bi-list"></i>
          </button>
        </nav>

        <div className="p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
